import { API_URL } from '../../config';
import type { AuthHeadersFn } from './phoneSensorApi';
import type { MmwaveState } from './mmwave';

export interface MmwaveZone { id: number; name: string; status: string; }
export interface MmwaveDetail extends MmwaveState { zones: MmwaveZone[]; }

async function call<T>(path: string, init: RequestInit): Promise<T> {
  const resp = await fetch(`${API_URL}/api/mmwave${path}`, init);
  if (!resp.ok) throw new Error(`mmWave request failed (${resp.status})`);
  return resp.json();
}

export const getMmwave = (id: number, h: AuthHeadersFn) =>
  call<MmwaveDetail>(`/${id}`, { headers: h() });

export const mintMmwaveToken = (id: number, h: AuthHeadersFn) =>
  call<{ token: string; state_url: string }>(`/${id}/token`, { method: 'POST', headers: h() });

export const identifyMmwave = (id: number, h: AuthHeadersFn) =>
  call<{ queued: boolean; online: boolean }>(`/${id}/identify`, { method: 'POST', headers: h() });

export const setMmwavePlacement = (id: number, bearingDeg: number, rangeM: number, h: AuthHeadersFn) =>
  call<MmwaveState>(`/${id}/placement`, {
    method: 'PUT',
    headers: h(true),
    body: JSON.stringify({ bearing_deg: bearingDeg, range_m: rangeM }),
  });
